<script setup lang="ts">

import { faReceipt } from '@fortawesome/pro-regular-svg-icons'

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { BtnPrimary } from '@shared/ui/buttons'
import { AppInput } from '@shared/ui/inputs'
import { AppSelect } from '@shared/ui/selects'
import { AppIcon } from '@shared/ui/icons'

import { useFiltersPromocodes } from '../model/filters-promocodes.hook'

defineOptions({
  name: 'FiltersPromocodes',
})

const {
  refSearch,
  refStatus,
  refDiscount,
  refDateRange,
  statusOptions,
  discountOptions,
  canManage,
  isLoading,
  submitSearch,
  clearFilters,
  openCreateModal,
} = useFiltersPromocodes()
</script>

<template>
  <FiltersBar
    class="filters-promocodes"
    :loading="isLoading"
    @click:submit="submitSearch"
    @click:clear="clearFilters"
  >
    <template #fields>
      <AppInput
        v-model="refSearch"
        class="filters-promocodes__search"
        label="Search"
        placeholder="Promo code"
      />

      <FilterDateRange
        v-model="refDateRange"
        class="filters-promocodes__date"
        label="Date"
        placeholder="Select range"
      />

      <AppSelect
        v-model="refStatus"
        class="filters-promocodes__select"
        :options="statusOptions"
        label="Status"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />

      <AppSelect
        v-model="refDiscount"
        class="filters-promocodes__select"
        :options="discountOptions"
        label="Discount"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
    </template>

    <template #end>
      <BtnPrimary
        v-if="canManage"
        text="Create promo code"
        color="emerald"
        element-width="auto"
        :disabled="isLoading"
        @click="openCreateModal"
      >
        <template #iconLeft>
          <AppIcon
            :icon="faReceipt"
            color="white"
          />
        </template>
      </BtnPrimary>
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersPromocodes.scss" />
